import { render } from "./carruselultimo.vue?vue&type=template&id=48c990b7&scoped=true"
import script from "./carruselultimo.vue?vue&type=script&lang=js"
export * from "./carruselultimo.vue?vue&type=script&lang=js"

import "./carruselultimo.vue?vue&type=style&index=0&id=48c990b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c990b7"]])

export default __exports__